import React from "react";
import "./svgButton.css";
import styled from "styled-components";

const Button = styled.button`
  background-color: #f8f9fa;
  color: #868a91;
  border: none;
  border-radius: 100px;
  height: 40px;
  width: 40px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.1s, color 0.1s;
  &:hover,
  &:focus,
  &:active {
    background-color: ${(props) =>
      props["data-hovercolor"] ? "#000000" : "#ff5837"};
    color: ${(props) => props["data-hovercolor"] || "#fff"};
    i {
      color: ${(props) => props["data-hovercolor"] || "#fff"};
    }
  }
`;
function SVGButton({
  hoverColor,
  icon,
  type = "button",
  onClick,
  className,
  ...restProps
}) {
  return (
    <Button
      {...restProps}
      data-hovercolor={hoverColor}
      // icon={icon}
      className={`d-flex justify-content-center align-items-center ${className}`}
      type={type}
      onClick={onClick}
    >
      {icon === "cancelIcon" ? (
        <i className="bi bi-x fa-lg editBtnIcon"></i>
      ) : icon === "deleteIcon" ? (
        <i className="bi bi-trash editBtnIcon"></i>
      ) : icon === "doneIcon" ? (
        <i className="bi bi-check2 fa-lg editBtnIcon"></i>
      ) : (
        <i className="bi bi-pencil-fill editBtnIcon"></i>
      )}
    </Button>
  );
}

export default SVGButton;
